import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { formatRate } from '@/lib/format';
import type { InterestRateType } from '@shared/types';

// Duplicado deliberadamente pequeño de utils/interest.ts del backend: son
// 2 fórmulas triviales y evita depender del backend para una vista previa
// instantánea en el input mientras el usuario escribe.
const eaToMv = (ea: number) => Math.pow(1 + ea, 1 / 12) - 1;
const mvToEa = (mv: number) => Math.pow(1 + mv, 12) - 1;

/**
 * Número + toggle E.A./M.V. con vista previa en vivo de la conversión.
 * Es el componente que hace que la app se sienta hecha para Colombia.
 */
export function RateInput({
  ratePercent,
  rateType,
  onChangeRate,
  onChangeType,
}: {
  ratePercent: number; // ej. 28 para 28%
  rateType: InterestRateType;
  onChangeRate: (percent: number) => void;
  onChangeType: (type: InterestRateType) => void;
}) {
  const fraction = ratePercent / 100;
  const other = rateType === 'EA' ? eaToMv(fraction) : mvToEa(fraction);

  return (
    <div className="space-y-1.5">
      <div className="flex gap-2">
        <Input
          type="number"
          step="0.01"
          min={0}
          value={Number.isFinite(ratePercent) ? ratePercent : ''}
          onChange={(e) => onChangeRate(Number(e.target.value))}
          className="flex-1"
        />
        <div className="flex overflow-hidden rounded-md border border-input">
          <Button
            type="button"
            variant={rateType === 'EA' ? 'primary' : 'ghost'}
            size="sm"
            className="rounded-none"
            onClick={() => onChangeType('EA')}
          >
            E.A.
          </Button>
          <Button
            type="button"
            variant={rateType === 'MV' ? 'primary' : 'ghost'}
            size="sm"
            className="rounded-none"
            onClick={() => onChangeType('MV')}
          >
            M.V.
          </Button>
        </div>
      </div>
      {ratePercent > 0 && (
        <p className="text-xs text-muted-foreground">
          equivale a{' '}
          {rateType === 'EA' ? (
            <>
              <strong>{formatRate(other)} M.V.</strong> / {formatRate(fraction)} E.A.
            </>
          ) : (
            <>
              {formatRate(fraction)} M.V. / <strong>{formatRate(other)} E.A.</strong>
            </>
          )}
        </p>
      )}
    </div>
  );
}
